import { IApplicationState } from '../../types/redux';

export const getPolygon = (state: IApplicationState): number[][] | null => {
  return state.newbuilding.polygon;
};
